/**
 * module name - buyNftOrder
 * 法币购买nft订单信息
 */

export default {
  namespaced: true,
  state: {
    //订单号
    orderNo: "",
    //支付方式信息
    payMethodInfo: {
      payWayCode: "",
      payWayName: "",
      bankCode: "",
      symbol: "",
      amountTotal: "",
    },
    //信用卡支付卡信息 - fullName
    cardFullName: "",
    //信用卡支付卡信息
    cardInfo_creditCard: {},
    //历史卡信息id
    cardId: "",
    //当前支付方式rampFee(确认订单需要)
    rampFee: "",
    //IDR - 银行信息
    VA_bankInfo: {},
  },
  mutations: {
    set_orderNo(state, newData) {
      state.orderNo = newData;
    },
    set_cardInfo_creditCard(state, newData) {
      state.cardInfo_creditCard = newData;
    },
    set_cardFullName(state, newData) {
      state.cardFullName = newData;
    },
    set_payMethodInfo(state, newData) {
      state.payMethodInfo = newData;
    },
    set_rampFee(state, newData) {
      state.rampFee = newData;
    },
    set_cardId(state, newData) {
      state.cardId = newData;
    },
    set_VA_bankInfo(state, newData) {
      state.VA_bankInfo = newData;
    },
  },
};
